<template>
  <div v-if="isVisible" class="splashScreen loadingPage" id="loadingPage" style="opacity: 30%; z-index: 1500;">
<!--    <div class="waivLogo">
      <img class="waivLogo1" src="/static/img/WAIVLogo1.svg" alt="">
      <img class="waivLogo2" src="/static/img/WAIVLogo2.svg" alt="">
      <img class="waivLogo3" src="/static/img/WAIVLogo2.svg" alt="">
      <img class="waivLogo4" src="/static/img/WAIVLogo2.svg" alt="">
    </div>-->
    <img class="kovoLogo" :class="{ 'inverted': isLightTheme }" src="/static/img/KovoLogoWhite.svg" alt="">
  </div>
</template>

<script>
import { useThemeStore } from '@/stores/themeStore';

export default {
  name: 'LoadingPage',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  setup() {
    const themeStore = useThemeStore();
    return { themeStore };
  },
  computed: {
    isLightTheme() {
      return this.themeStore?.isLightTheme || false;
    }
  }
}
</script>

<style scoped>
.kovoLogo{
  animation: fade 4s ease-in-out infinite;
}

.kovoLogo.inverted {
  filter: invert(1);
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  50%{
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/*.waivLogo{
  height: 60px;
  width: 95px;
  display: flex;
  animation: fade 4s ease-in-out infinite;
}

@keyframes fade {
  0%{
    opacity: 0;
  }
  25%{
    opacity: 1;
  }
  75%{
    opacity: 1;
  }
  100%{
    opacity: 0;
  }
}

.waivLogo2{
  width: 20px;
  animation: rotate2 4s ease-in-out infinite;
  transform-origin: left bottom;
  opacity: 0;
}

@keyframes rotate2 {
  0%{
    transform: rotate(-30deg);
    opacity: 0;
  }
  25%{
    transform: rotate(-30deg);
    opacity: 0;
  }
  28%{
    opacity: 1;
  }
  31%{
    transform: rotate(0deg);
    opacity: 1;
  }
  100%{
    transform: rotate(0deg);
    opacity: 1;
  }
}

.waivLogo3{
  width: 20px;
  transform: scaleY(-1) translate(0, 100%);
  animation: rotate3 4s ease-in-out infinite;
  transform-origin: left bottom;
  opacity: 0;
}

@keyframes rotate3 {
  0%{
    transform: scaleY(-1) translate(0, 100%) rotate(-30deg);
    opacity: 0;
  }
  31%{
    transform: scaleY(-1) translate(0, 100%) rotate(-30deg);
    opacity: 0;
  }
  34%{
    opacity: 1;
  }
  37%{
    transform: scaleY(-1) translate(0, 100%) rotate(0deg);
    opacity: 1;
  }
  100%{
    transform: scaleY(-1) translate(0, 100%) rotate(0deg);
    opacity: 1;
  }
}

.waivLogo4{
  width: 20px;
  animation: rotate4 4s ease-in-out infinite;
  transform-origin: left bottom;
  opacity: 0;
}

@keyframes rotate4 {
  0%{
    transform: rotate(-30deg);
    opacity: 0;
  }
  37%{
    transform: rotate(-30deg);
    opacity: 0;
  }
  40%{
    opacity: 1;
  }
  43%{
    transform: rotate(0deg);
    opacity: 1;
  }
  100%{
    transform: rotate(0deg);
    opacity: 1;
  }
}*/

</style>
